import React from 'react';
import { useIsBusy } from '../../../data/hooks/ui/useIsBusy';
import ErrorBoundary from '../../validate/ErrorBoundary';
import NotificationDialog from './NotificationDialog/NotificationDialog';
import { useRecentNotifications } from '../../../data/hooks/notifications/useRecentNotifications';

const RecentNotifications = (props) => {
    const { eventId } = props,
        notifications = useRecentNotifications(eventId)
            .filter((notification) => !notification.read)
            .sort((n1, n2) => n1.sent_on > n2.sent_on),
        isBusy = useIsBusy();

    if (isBusy) return null;

    return (
        <ErrorBoundary>
            {notifications.map((notification) => (
                <NotificationDialog key={notification.id} notification={notification} />
            ))}
        </ErrorBoundary>
    );
};

export default (props) => <RecentNotifications {...props} />;
